export const menusConstants = {
    MENUS_REQUEST: 'MENUS_REQUEST',
    MENUS_SUCCESS: 'MENUS_SUCCESS',
    MENUS_ERROR: 'MENUS_ERROR',
};

export const DEFAULT_SECTION_NAME_BY_LANGUAGE = {
    GB: 'Main menu',
    UA: 'Головне меню',
    ES: 'Menú principal',
    PT: 'Menu principal',
    PL: 'Menu główne',
    DE: 'Hauptmenü',
};

export const MENU_TEXT_LIMITS = {
    name: 140,
    description: 1000,
    ingredients: 5000,
};

// Target length for AI-written menu descriptions — they should stay short and punchy
export const MENU_AI_DESCRIPTION_LIMIT = 150;

// Google Food Menus enum values. Google uses BREAK_FAST, not BREAKFAST.
export const CUISINES = [
    'AMERICAN',
    'ASIAN',
    'BRAZILIAN',
    'BREAK_FAST',
    'BRUNCH',
    'CHICKEN',
    'CHINESE',
    'FAMILY',
    'FAST_FOOD',
    'FRENCH',
    'GREEK',
    'GERMAN',
    'HAMBURGER',
    'INDIAN',
    'INDONESIAN',
    'ITALIAN',
    'JAPANESE',
    'KOREAN',
    'LATIN_AMERICAN',
    'MEDITERRANEAN',
    'MEXICAN',
    'PAKISTANI',
    'PIZZA',
    'SEAFOOD',
    'SPANISH',
    'SUSHI',
    'THAI',
    'TURKISH',
    'VEGETARIAN',
    'VIETNAMESE',
    'OTHER_CUISINE',
];

export const SPICINESS_LEVELS = ['MILD', 'MEDIUM', 'HOT'];

export const ALLERGENS = ['DAIRY', 'EGG', 'FISH', 'PEANUT', 'SHELLFISH', 'SOY', 'TREE_NUT', 'WHEAT'];

export const DIETARY_RESTRICTIONS = ['HALAL', 'KOSHER', 'ORGANIC', 'VEGAN', 'VEGETARIAN'];

export const PREPARATION_METHODS = [
    'BAKED',
    'BARBECUED',
    'BASTED',
    'BLANCHED',
    'BOILED',
    'BRAISED',
    'CODDLED',
    'FERMENTED',
    'FRIED',
    'GRILLED',
    'KNEADED',
    'MARINATED',
    'PAN_FRIED',
    'PICKLED',
    'PRESSURE_COOKED',
    'ROASTED',
    'SAUTEED',
    'SEARED',
    'SIMMERED',
    'SMOKED',
    'STEAMED',
    'STEEPED',
    'STIR_FRIED',
    'OTHER_METHOD',
];

export const NUTRITION_UNIT_DEFAULTS = {
    totalFat: 'GRAM',
    cholesterol: 'MILLIGRAM',
    sodium: 'MILLIGRAM',
    totalCarbohydrate: 'GRAM',
    protein: 'GRAM',
};

export const MASS_UNITS = ['GRAM', 'MILLIGRAM'];
